import React from "react";

const Docs = () => {
  return <div className="h-screen p-3 bg-gray-100">Docs</div>;
};

export default Docs;
